import Swiper from "swiper";
import { Pagination } from "swiper/modules";

const swiper = new Swiper(".swiper", {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
});
